import type { ColumnDef } from '@tanstack/vue-table'
import type { UserType, UserTableActions } from './baseColumns'
import { createActiveUsersColumns } from './activeUsersColumns'
import { createPendingUsersColumns } from './pendingUsersColumns'
import { createDeactivatedUsersColumns } from './deactivatedUsersColumns'

export type { UserType, RoleFilterOption, UserTableActions } from './baseColumns'
export { createActiveUsersColumns } from './activeUsersColumns'
export { createPendingUsersColumns } from './pendingUsersColumns'
export { createDeactivatedUsersColumns } from './deactivatedUsersColumns'

export const createManageUsersColumns = (
  userType: UserType,
  actions?: UserTableActions,
): ColumnDef<ManageUserTableRow>[] => {
  switch (userType) {
    case 'active':
      return createActiveUsersColumns(actions)
    case 'pending':
      return createPendingUsersColumns(actions)
    case 'deactivated':
      return createDeactivatedUsersColumns(actions)
  }
}
